import { css } from '@emotion/react'
import { Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, Text, VFlow } from 'bold-ui'
import printEncerrarGestacao from 'images/acompanhamento/print-encerrar-gestacao.svg'
import { useHistory } from 'react-router'

export interface GestacaoSemDesfechoModalProps {
  onClose: () => void
  isModalOpen: boolean
  basePath: string
  showSoapButton: boolean
}

export function GestacaoSemDesfechoModal(props: Readonly<GestacaoSemDesfechoModalProps>) {
  const { onClose, isModalOpen, basePath, showSoapButton } = props

  const history = useHistory()

  const handleSoapButtonClick = () => {
    history.push(`${basePath}/soap`)
  }

  return (
    <Modal onClose={onClose} open={isModalOpen}>
      <ModalHeader
        title='Ajuda sobre o desfecho da gestação'
        hasCloseButton
        icon={{
          fill: 'info',
          name: 'infoCircleOutline',
        }}
      />
      <ModalBody>
        <VFlow vSpacing={1}>
          <Text component='p'>
            Para realizar o desfecho de uma gestação no sistema, o profissional deve incluir um CIAP 2/CID 10
            correspondentes na lista de problemas/condições na Avaliação do SOAP.
          </Text>
          <Text component='p'>
            <Text fontWeight='bold'>CIAP2: </Text>
            W82, W83, W90, W91, W92, W93.
          </Text>
          <Text component='p'>
            <Text fontWeight='bold'>CID10: </Text>
            O02, O03, O04, O05, O06, Z303, O42, O45, O60, O61, O62, O63, O64, O65, O66, O67, O68, O69, O70, O71, O73,
            O750, O751, O754, O755, O756, O757, O758, O759, O80, O81, O82, O83, O84, Z370, Z371, Z372, Z373, Z374, Z375,
            Z376, Z377, Z379, Z38, Z39.
          </Text>
          <Text component='p'>
            O sistema irá habilitar uma seção de encerramento de gestação, podendo indicar novamente o tipo de gravidez
            e a data do desfecho.
          </Text>
        </VFlow>
        <VFlow
          vSpacing={0}
          style={css`
            text-align: center;
          `}
        >
          <img src={printEncerrarGestacao} alt='Como encerrar a gestação no sistema' />
          <Text color='secondary' fontStyle='italic'>
            Imagem meramente ilustrativa
          </Text>
        </VFlow>
      </ModalBody>
      {showSoapButton && (
        <ModalFooter
          style={css`
            text-align: end;
          `}
        >
          <ModalFooterButton skin='outline' kind='primary' onClick={handleSoapButtonClick}>
            Ir para o SOAP
          </ModalFooterButton>
        </ModalFooter>
      )}
    </Modal>
  )
}
